import { z } from 'zod';
import { digestStatusSchema } from '../enums.js';
import { postDtoSchema } from './post.js';
/** The window a digest covers is a calendar day in this zone, not UTC. */
export const DIGEST_TIMEZONE = 'Europe/Paris';
export const digestItemSchema = z.object({
    rank: z.number().int(),
    relevance: z.number().nullable(),
    rationale: z.string().nullable(),
    post: postDtoSchema,
});
export const digestDtoSchema = z.object({
    id: z.string(),
    /** Calendar day in DIGEST_TIMEZONE, as YYYY-MM-DD. */
    date: z.string(),
    status: digestStatusSchema,
    headline: z.string().nullable(),
    summary: z.string().nullable(),
    model: z.string().nullable(),
    promptTokens: z.number().int().nullable(),
    completionTokens: z.number().int().nullable(),
    /** Micro-dollars: 1_000_000 = $1, avoiding floating point drift on cents. */
    costMicros: z.number().int().nullable(),
    generatedAt: z.string().nullable(),
    error: z.string().nullable(),
    items: z.array(digestItemSchema),
});
export const generateDigestRequestSchema = z.object({
    /** Defaults to today in DIGEST_TIMEZONE. */
    date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
    /** Regenerate even if a digest already exists for that day. */
    force: z.boolean().default(false),
});
export const DEFAULT_DIGEST_PROMPT = `Tu es l'analyste personnel de l'opérateur de Big Brother, un outil de veille sur X.

À partir des posts de la journée fournis ci-dessous, rédige un briefing en français.

Attentes :
- Commence par une ligne de titre qui résume la journée en moins de 100 caractères.
- Regroupe ensuite par thème, pas par compte ni par ordre chronologique.
- Hiérarchise : ce qui est urgent ou dramatique d'abord, l'anecdotique en dernier ou pas du tout.
- Recoupe les sources : si plusieurs comptes rapportent le même fait, dis-le en une fois.
- Signale explicitement les contradictions entre sources.
- Reste factuel. N'invente rien qui ne soit pas dans les posts.
- Si un post a été supprimé par son auteur, mentionne-le, c'est un signal en soi.
- Sois dense. Vise 300 à 600 mots.`;
export const digestSettingsSchema = z.object({
    prompt: z.string().max(8000),
});
//# sourceMappingURL=digest.js.map